import CompaniesCollection from "../../gd-model/tree/companies-collection";
import {ProjectTree} from "../../gd-model/tree/@type";

// I think this should be deprecated
export type TypeProjectListItem = {
    id          : ID
    companyId   : ID
    access      : number // ????
    color       : number
    name        : string
    parent      : TypeProjectListItem | null
    parentId    : ID
    sortPosition: number
    systemType  : number // ?????
}

// ochen' bad and deprecated function

export default class ProjectsListManager {

    static getChildProjects(companyId: ID|null, projectId?: ID | null, orderBy:string = 'name', filterByAccess:boolean = false, treeSource?: any):ProjectTree[] {

        const source : CompaniesCollection = treeSource ? treeSource : gd.tree

        // let res: ProjectSession[] = []
        let res: ProjectTree[] = []

        if(projectId) {
            const treeProject = source.getProject(projectId)
            if (treeProject && treeProject.children) res = treeProject.children.list()
        } else if (companyId) {
            const treeCompany = source.getCompany(companyId)
            if (treeCompany && treeCompany.projects) { // there is some sort of problem with "reconnect" in session
                res = filterByAccess ? treeCompany.projects.mainMenuProjects : treeCompany.projects.list()
            }
        }

        switch (orderBy) {
            case 'sortPosition' :
                res = _.orderBy(res, i=>i.sortPosition, ['asc'])
                break

            case 'name'         :
            default             :
                res = _.orderBy(res, i=>i.name.toLowerCase(), ['asc'])
                break
        }

        return res
    }
}
